<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{caption}}<strong v-if="required" class="required">*</strong>
        </template>
        <template slot="input">
            <div class="checkbox-container" @click="switchValue">

                <div :class="{ 'checkbox-switch': true, 'checkbox-on': value }">
                    <icon :style="{color: value ? 'white' : undefined}" :icon="['far', value ? 'check' : 'times']" size="sm"/>

                </div>

            </div>
        </template>
    </form-input-layout>
</template>

<script>
    import FormInputMixin from "./FormInputMixin";
    import FormInputLayout from "./FormInputLayout";

    export default {
        name: "FormCheckboxInput",
        components: {FormInputLayout},
        mixins: [FormInputMixin],
        props: {
            value: {
                type: Boolean,
                default: false
            },
            helpItemCode: String
        },
        data: function () {
            return {}
        },
        methods: {
            switchValue() {
                this.$emit('input', !this.value);
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../styles/global";

    .checkbox-container {
        cursor: pointer;
        background-color: var(--input-check-off-background-color);
        width: 18px;
        height: 18px;
        user-select: none;
        border: 1px solid var(--input-check-off-background-color);
        border-radius: 9px;
    }

    .checkbox-on {
        background-color: var(--accent-color) !important;
        transition: all 300ms;
    }

    .checkbox-switch {
        border-radius: 9px;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        justify-items: center;
        background-color: transparent;
        transition: all 300ms;
    }

</style>